export default {
  setMemoryState(state, payload) {
    state.memory = payload;
  },
  setMemoryLoadingState(state, payload) {
    state.memoryLoading = payload;
  },
  setMemorySubmitLoadingState(state, payload) {
    state.submitLoading = payload;
  },
};
